import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const ParentCoachingProgramPageSession = React.lazy(() => import('../programs/parentcoachingprogram/ParentCoachingProgramSession'));
const ParentCoachingProgramPageHeader = React.lazy(() => import('../programs/parentcoachingprogram/ParentCoachingProgramHeader'));

function ParentCoachingProgramPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <ParentCoachingProgramPageHeader />
       <ParentCoachingProgramPageSession />
      </Suspense>
    </div>
  );
}

export default ParentCoachingProgramPage;
